const MockElement = (props) => (
  <div className="bg-gray-200 rounded-md p-8 my-3 text-center">
    <h2 className="text-lg font-bold">{props.headline || props.title}</h2>
    <h3>{props.type || props._type}</h3>
  </div>
)

export default MockElement
